import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
} from "@mui/icons-material";
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import {
  TABLE_PAGE_SIZE_OPTIONS,
  TablePageSize,
  TablePaginationState,
} from "../../helpers/table-pagination-url";

type TablePaginationControlsProps = {
  pagination: TablePaginationState;
  firstVisibleIndex: number;
  lastVisibleIndex: number;
  totalItems: number;
  totalPages: number;
  onPageSizeChange: (size: TablePageSize) => void;
  onFirstPage: () => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onLastPage: () => void;
};

export const TablePaginationControls = ({
  pagination,
  firstVisibleIndex,
  lastVisibleIndex,
  totalItems,
  totalPages,
  onPageSizeChange,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
}: TablePaginationControlsProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
        mt: 1,
      }}
    >
      <FormControl size="small" sx={{ minWidth: 90, mr: 1 }}>
        <Select
          value={String(pagination.pageSize)}
          onChange={(event) => {
            onPageSizeChange(Number(event.target.value) as TablePageSize);
          }}
        >
          {TABLE_PAGE_SIZE_OPTIONS.map((size) => (
            <MenuItem key={size} value={String(size)}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        {`${firstVisibleIndex}-${lastVisibleIndex} / ${totalItems}`}
      </Typography>
      <IconButton
        size="small"
        disabled={pagination.page <= 1}
        onClick={onFirstPage}
        aria-label="first page"
      >
        <FirstPage fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        disabled={pagination.page <= 1}
        onClick={onPreviousPage}
        aria-label="previous page"
      >
        <ChevronLeft fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        disabled={pagination.page >= totalPages}
        onClick={onNextPage}
        aria-label="next page"
      >
        <ChevronRight fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        disabled={pagination.page >= totalPages}
        onClick={onLastPage}
        aria-label="last page"
      >
        <LastPage fontSize="small" />
      </IconButton>
    </Box>
  );
};
